import AbstractFetch from '~/repositories/AbstractFetch';
import type { IFetchOptions, IResponse } from '~/types/repositories';
import type { IMenuApiResponse, IMenuCategoriesApiResponse } from '~/modules/menu/types/menu';

export default class Menu extends AbstractFetch {
  private static readonly MENUS = 'v1/menus/';

  constructor(fetchOptions: IFetchOptions) {
    super(fetchOptions.baseURL, fetchOptions.fetch);
  }

  /**
   * @deprecated
   */
  async getMenu(type: 'header' = 'header'): Promise<IResponse<IMenuApiResponse>> {
    const params = new URLSearchParams();
    params.append('menu', type);

    return await this.fetch(Menu.MENUS, {
      queryParams: params.toString(),
    });
  }

  async getCategoriesMenu(type: 'header' = 'header'): Promise<IResponse<IMenuCategoriesApiResponse>> {
    const params = new URLSearchParams();
    params.append('menu', type);

    return await this.fetch(Menu.MENUS, {
      queryParams: params.toString(),
    });
  }
}
